import { render, staticRenderFns } from "./MontageTableRow.vue?vue&type=template&id=45e74801&"
import script from "./MontageTableRow.vue?vue&type=script&lang=ts&"
export * from "./MontageTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports